module.exports = __webpack_public_path__ + "images/news-banner.c877612.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/news-banner.png
// module id = 639
// module chunks = 0